import {BaseResponse} from "./ortak.dtos";
import {BaseRequest, IReturn} from "./ebld.dtos";

export class YilTasima {
  public piOkunacakYil: number = null;
  public piYazilacakYil: number = null;
  public piArtisOran?: number;

}

export class GetParametreDeger_Response extends BaseResponse
{
  public parametreDeger: string;
  public decimalDeger: number;
  public longDeger: number;

  public constructor(init?: Partial<GetParametreDeger_Response>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/System/GetParametreDeger")
export class GetParametreDeger_Request extends BaseRequest<GetParametreDeger_Response> implements IReturn<GetParametreDeger_Response>
{
  public parametreAdi: string;

  public constructor(init?: Partial<GetParametreDeger_Request>) { super(init); (Object as any).assign(this, init); }
  public getTypeName() { return 'GetParametreDeger_Request'; }
  public getMethod() { return 'POST'; }
  public createResponse() { return new GetParametreDeger_Response(); }
}
